import Layout from '@/components/feature/Layout';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import LatestNews from './components/LatestNews';
import HotVideos from './components/HotVideos';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  return (
    <Layout overlay pushDown={false}>
      <HeroCarousel />
      <CategoryQuickLinks />
      <LatestNews />
      <HotVideos />
      <SiteIntro />
    </Layout>
  );
}